import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-player-card',
  templateUrl: './main-page-iraq.component.html',
  styleUrls: ['./main-page-iraq.component.scss']
})
export class MainPageIraqComponent implements OnInit {

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  tournaments ;

  ngOnInit(): void {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute();
    });
  }
  changeRoute() {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('tecno-pubg-mobile-cup-2-iraq', 1, 'pubg').subscribe(res => {
      this.tournaments= res.data
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })
  }
}
